export class CmsAboutUsLandingProperties {
  aboutUsID: number= 0;
  mainTitle: string = "";
  backgroundImage: string = "";
  landingTitle: string = "";
  landingDetails: string = "";
  landingImage: string = "";
  landingImageName: string = "";
  logo: string = "";
}
export class CmsAboutUsServicesProperties {
  serviceID: number = 0;
  ticketingTitle: string = "";
  ticketingDescription: string = "";
  voyagesTitle: string = "";
  voyagesDescription: string = "";
  hotelingTitle: string = "";
  hotelingDescription: string = "";
  othersTitle: string = "";
  othersDescription: string = "";
}
export class CmsAboutUsTimelineProperties {
  timelineID: number = 0;
  timelineTitle: string = "";
  timelineDescription: string = "";
  occasionTime: Date;
  occasionTitle: string = "";
  occasionDescription: string = "";
  occasionImage: string = "";
}
